import { FC } from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaWhatsapp } from "react-icons/fa";

const Footer: FC = () => {
  return (
    <footer className="hidden md:block bg-gray-100 text-gray-700 border-t ">
      <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left Section */}
        <div className="text-center md:text-left space-y-2">
          <h2 className="text-lg font-semibold text-gray-900">Fleeby</h2>
          <p className="text-sm">
            Beautiful handcrafted resin art & creative decor — made with love in
            Kerala.
          </p>
        </div>

        {/* Center Section - Policies */}
        <div className="flex flex-col items-center md:items-start space-y-2">
          <h3 className="text-md font-semibold text-gray-900">Quick Links</h3>
          <nav className="flex flex-col text-sm space-y-1">
            <Link
              to="/privacy-policy"
              className="hover:text-black transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/shipping-policy"
              className="hover:text-black transition-colors"
            >
              Shipping Policy
            </Link>
            <Link
              to="/refund-policy"
              className="hover:text-black transition-colors"
            >
              Cancellation & Refund Policy
            </Link>
            <Link to="/terms" className="hover:text-black transition-colors">
              Terms & Conditions
            </Link>
          </nav>
        </div>

        {/* Right Section - Contact & Socials */}
        <div className="flex flex-col items-center md:items-end space-y-2">
          <h3 className="text-md font-semibold text-gray-900">Support</h3>
          <a
            href="mailto:info@fleeby.in"
            className="text-sm hover:text-black transition-colors"
          >
            info@fleeby.in
          </a>

          <div className="flex items-center gap-4 mt-2">
            <a
              title="Instagram"
              href="https://www.instagram.com/fleeby.in"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-black transition-colors"
            >
              <FaInstagram size={20} />
            </a>
            <a
              title="Facebook"
              href="https://www.facebook.com/fleeby.in"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-black transition-colors"
            >
              <FaFacebook size={20} />
            </a>
            <a
              title="WhatsApp"
              href="https://wa.me/919778461609"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-black transition-colors"
            >
              <FaWhatsapp size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="border-t text-center py-4 text-xs text-gray-500">
        © 2025 Fleeby.in — All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
